import React from 'react'
import { Switch, Route, BrowserRouter } from 'react-router-dom'
import _ from 'lodash'

import SignedInLayout from 'ui/layouts/signedIn'

import Login from 'ui/views/auths/Login'
import PasswordChange from 'ui/views/auths/PasswordChange'
import PasswordConfirmRecover from 'ui/views/auths/PasswordConfirmRecover'
import PasswordRecover from 'ui/views/auths/PasswordRecover'

// import Plan from 'ui/views/Plan'
import Approved from 'ui/views/consults/Approved'
import Inexistent from 'ui/views/consults/Inexistent'
import ApprovedPep from 'ui/views/consults/ApprovedPep'
import ApprovedProcessesUnclassified from 'ui/views/consults/ApprovedProcessesUnclassified'
import ApprovedProcessesWhitelist from 'ui/views/consults/ApprovedProcessesWhitelist'
import ApprovedContingency from 'ui/views/consults/ApprovedContingency'
import Processing from 'ui/views/consults/Processing'
import Blacklist from 'ui/views/consults/Blacklist'
import Reproved from 'ui/views/consults/Reproved'
// import WithError from 'ui/views/consults/WithError'
import Pending from 'ui/views/consults/Pending'
import Total from 'ui/views/consults/Total'
import Analytics from 'ui/views/analytics/Analytics'
import AnalyticsProcessTime from 'ui/views/analytics/AnalyticsProcessTime'
import AnalyticsServices from 'ui/views/analytics/AnalyticsServices'
import AnalyticsServicesProcessTime from 'ui/views/analytics/AnalyticsServicesProcessTime'
import BatchProcessing from 'ui/views/batch/Processing'
import BatchProcessed from 'ui/views/batch/Processed'

// Manual derivation
import ManualDerivationAnalysisAnalystInQueueOnlyPep from 'ui/views/manualDerivation/Analysis/analyst/InQueueOnlyPep'
import ManualDerivationAnalysisAnalystInQueueOnlyProcesses from 'ui/views/manualDerivation/Analysis/analyst/InQueueOnlyProcesses'
import ManualDerivationAnalysisAnalystInQueuePepAndProcesses from 'ui/views/manualDerivation/Analysis/analyst/InQueuePepAndProcesses'

import ManualDerivationAnalysisSupervisorInQueueOnlyPep from 'ui/views/manualDerivation/Analysis/supervisor/InQueueOnlyPep'
import ManualDerivationAnalysisSupervisorInQueueOnlyProcesses from 'ui/views/manualDerivation/Analysis/supervisor/InQueueOnlyProcesses'
import ManualDerivationAnalysisSupervisorInQueuePepAndProcesses from 'ui/views/manualDerivation/Analysis/supervisor/InQueuePepAndProcesses'

import ManualDerivationAnalysisInAnalysis from 'ui/views/manualDerivation/Analysis/InAnalysis'
import ManualDerivationAnalysisFinalizedApproved from 'ui/views/manualDerivation/Analysis/FinalizedApproved'
import ManualDerivationAnalysisFinalizedReproved from 'ui/views/manualDerivation/Analysis/FinalizedReproved'
import ManualDerivationAnalysisTotal from 'ui/views/manualDerivation/Analysis/Total'
// Manual derivation

import { PANEL_ENVS } from 'utils/constants/environments'
import {
  ADMIN_PATHS,
  CONFIG_PATHS,
  DOC_PATHS,
  MASTER_PATHS,
  NEWS_PATHS,
} from 'utils/constants/routerPaths'

import SecuredRoute from './securedRoute'

const renderSecuredRoute = (path, component) => {
  return (
    <SecuredRoute
      // key={path} // Se descomentar toda a tela e atualizada quando clica em alguma rota
      path={path}
      parent={SignedInLayout}
      child={component}
    />
  )
}

const renderSecuredRoutes = (paths) => {
  return _.chain(paths)
          .values()
          .map(route => renderSecuredRoute(route.PATH, route.COMPONENT))
          .value()
}

const renderRoutesByDoc = (docType) => {
  return [
    /* BV: desativado pois nao existe essa funcionalidade nesse painel
    <SecuredRoute
      type={docType}
      path={`/${docType}/plan`}
      parent={SignedInLayout}
      child={Plan}
    />,
    */

    <SecuredRoute
      type={docType}
      path={`/${docType}/total`}
      parent={SignedInLayout}
      child={Total}
    />,

    <SecuredRoute
      type={docType}
      path={`/${docType}/approved`}
      parent={SignedInLayout}
      child={Approved}
    />,

    /* BV: desativado pois nao existe essa funcionalidade nesse painel
    <SecuredRoute
      type={docType}
      path={`/${docType}/in_attention`}
      parent={SignedInLayout}
      child={Attention}
    />,
    */

    <SecuredRoute
      type={docType}
      path={`/${docType}/reproved`}
      parent={SignedInLayout}
      child={Reproved}
    />,

    <SecuredRoute
      type={docType}
      path={`/${docType}/inexistent`}
      parent={SignedInLayout}
      child={Inexistent}
    />,

    <SecuredRoute
      type={docType}
      path={`/${docType}/processing`}
      parent={SignedInLayout}
      child={Processing}
    />,

    <SecuredRoute
      type={docType}
      path={`/${docType}/blocked`}
      parent={SignedInLayout}
      child={Blacklist}
    />,

    /* BV: desativado pois nao existe essa funcionalidade nesse painel
    <SecuredRoute
      type={docType}
      path={`/${docType}/with-error`}
      parent={SignedInLayout}
      child={WithError}
    />,
    */

    <SecuredRoute
      type={docType}
      path={`/${docType}/pending`}
      parent={SignedInLayout}
      child={Pending}
    />,

    <SecuredRoute
      type={docType}
      path={`/${docType}/analytics-consults`}
      parent={SignedInLayout}
      child={Analytics}
    />,

    <SecuredRoute
      type={docType}
      path={`/${docType}/analytics-services`}
      parent={SignedInLayout}
      child={AnalyticsServices}
    />,

    <SecuredRoute
      type={docType}
      path={`/${docType}/analytics-time-consults`}
      parent={SignedInLayout}
      child={AnalyticsProcessTime}
    />,

    <SecuredRoute
      type={docType}
      path={`/${docType}/analytics-time-services`}
      parent={SignedInLayout}
      child={AnalyticsServicesProcessTime}
    />,

    <SecuredRoute
      type={docType}
      path={`/${docType}/batch/processing`}
      parent={SignedInLayout}
      child={BatchProcessing}
    />,

    <SecuredRoute
      type={docType}
      path={`/${docType}/batch/processed`}
      parent={SignedInLayout}
      child={BatchProcessed}
    />,

    <SecuredRoute
      type={docType}
      path={`/${docType}/approved-pep`}
      parent={SignedInLayout}
      child={ApprovedPep}
    />,

    <SecuredRoute
      type={docType}
      path={`/${docType}/approved-processes-whitelist`}
      parent={SignedInLayout}
      child={ApprovedProcessesWhitelist}
    />,

    <SecuredRoute
      type={docType}
      path={`/${docType}/approved-processes-unclassified`}
      parent={SignedInLayout}
      child={ApprovedProcessesUnclassified}
    />,

    <SecuredRoute
      type={docType}
      path={`/${docType}/approved-contingency`}
      parent={SignedInLayout}
      child={ApprovedContingency}
    />,

    <SecuredRoute
      type={docType}
      path={`/${docType}/manual-analysis/total`}
      parent={SignedInLayout}
      child={ManualDerivationAnalysisTotal}
    />,

    <SecuredRoute
      type={docType}
      path={`/${docType}/manual-analysis/analyst/in-queue-only-pep`}
      parent={SignedInLayout}
      child={ManualDerivationAnalysisAnalystInQueueOnlyPep}
    />,

    <SecuredRoute
      type={docType}
      path={`/${docType}/manual-analysis/analyst/in-queue-only-processes`}
      parent={SignedInLayout}
      child={ManualDerivationAnalysisAnalystInQueueOnlyProcesses}
    />,

    <SecuredRoute
      type={docType}
      path={`/${docType}/manual-analysis/analyst/in-queue-pep-processes`}
      parent={SignedInLayout}
      child={ManualDerivationAnalysisAnalystInQueuePepAndProcesses}
    />,

    <SecuredRoute
      type={docType}
      path={`/${docType}/manual-analysis/supervisor/in-queue-only-pep`}
      parent={SignedInLayout}
      child={ManualDerivationAnalysisSupervisorInQueueOnlyPep}
    />,

    <SecuredRoute
      type={docType}
      path={`/${docType}/manual-analysis/supervisor/in-queue-only-processes`}
      parent={SignedInLayout}
      child={ManualDerivationAnalysisSupervisorInQueueOnlyProcesses}
    />,

    <SecuredRoute
      type={docType}
      path={`/${docType}/manual-analysis/supervisor/in-queue-pep-processes`}
      parent={SignedInLayout}
      child={ManualDerivationAnalysisSupervisorInQueuePepAndProcesses}
    />,

    <SecuredRoute
      type={docType}
      path={`/${docType}/manual-analysis/in-analysis`}
      parent={SignedInLayout}
      child={ManualDerivationAnalysisInAnalysis}
    />,

    <SecuredRoute
      type={docType}
      path={`/${docType}/manual-analysis/finalized-approved`}
      parent={SignedInLayout}
      child={ManualDerivationAnalysisFinalizedApproved}
    />,

    <SecuredRoute
      type={docType}
      path={`/${docType}/manual-analysis/finalized-reproved`}
      parent={SignedInLayout}
      child={ManualDerivationAnalysisFinalizedReproved}
    />,
  ]
}

export default () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route path="/" exact component={Login} />
        <Route path="/password-change" exact component={PasswordChange} />
        <Route path="/password-confirm-recover" exact component={PasswordConfirmRecover} />
        <Route path="/password-recover" exact component={PasswordRecover} />

        {renderSecuredRoutes(CONFIG_PATHS)}
        {renderSecuredRoutes(DOC_PATHS)}
        {renderSecuredRoutes(ADMIN_PATHS)}
        {renderSecuredRoutes(MASTER_PATHS)}
        {renderSecuredRoutes(NEWS_PATHS)}

        {renderRoutesByDoc(PANEL_ENVS.CPF)}
        {renderRoutesByDoc(PANEL_ENVS.CNPJ)}

        <Route component={Login} />
      </Switch>
    </BrowserRouter>
  )
}
